module.exports = require('./helpers/bundle-url').getBundleURL('13ph5') + "flag_en.fc22f474.svg";